import { combineReducers } from "@reduxjs/toolkit";

import voucherFormReducer from "../pages/voucher-form/voucher-form.slice";
import voucherLinkReducer from "../pages/new-channel-partner-form/new-cp-form.slice";
import newBookingFormReducer from "../pages/new-booking-form/new-booking-form.slice";
import countryReducer from "../shared-components/phone-input/phone-input-slice"

const rootReducer = combineReducers({
  voucherForm: voucherFormReducer,
  voucherLink: voucherLinkReducer,
  newBookingForm: newBookingFormReducer,
  countries: countryReducer,
});

export default rootReducer;
